import { FloatingPortal } from '@floating-ui/react';

export default function TooltipPortal() {
    return <FloatingPortal id="floating-ui-root" />;
}
